module.exports = __webpack_public_path__ + "static/media/photo-circle.7018625e.png";